import styled from 'styled-components';
import { Modal } from 'lib/components/Modal/Modal';

export const StyledVncWarningOneIsOpenAlreadyModal = styled(Modal)``;
